/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "./styles/sign-in-up.css";
import { useNavigate } from "react-router-dom";
import { CheckCircleTwoTone } from "@ant-design/icons";

import { message } from "antd";
import { setVerificationStatus } from "../store/slices/VerifyPassword";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import {
  forgotInSchema,
  forgotInWithOrgId,
  forgotInWithOrgIdAndQues,
} from "../schemas";
import Axios from "../api/Axios";
import { Select } from "antd";
import ImagesSlider from "../components/ImagesSlider";
import { MAIN_LOGO_BIG } from "../ImagesSrc";
const { Option } = Select;
const initialValues = {
  emailAndUserId: "",
  orgId: "",
  question: undefined,
  givenQuestion: "",
  answer: "",
  givenAnswer: "",
};

const ForgotPassword = () => {
  // eslint-disable-next-line no-useless-escape
  const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
  // /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  const [nextClicked, setNextClicked] = useState(false);
  const [nextBlur, setNextBlur] = useState(false);
  const [showOrgId, setShowOrgId] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [checkEmail, setCheckEmail] = useState(false);
  const [questionExists, setQuestionExists] = useState(false);

  const [questionList, setQuestionlist] = useState();

  const [disAnswer, setDisAnswer] = useState(false);

  const [enterQnA, setEnterQnA] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [mailSent, setMailSent] = useState(false);

  const notExists = (msg) => {
    messageApi.open({
      type: "warning",
      content: msg,
      duration: 7,
    });
  };
  const enterValidOrgID = (props) => {
    messageApi.open({
      type: "warning",
      content: props,
      duration: 5,
    });
  };
  const mailNotSent = (props) => {
    messageApi.open({
      type: "warning",
      content: props,
      duration: 5,
    });
  };

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: checkEmail
      ? forgotInSchema
      : questionExists
      ? forgotInWithOrgIdAndQues
      : forgotInWithOrgId,
    onSubmit: (values) => {
      // handleFormSubmit(values);
      handleSetPasswordClick(values);
      //console.log("logiing formik", values);
    },
  });

  const history = useNavigate();
  const OnlyEmailSubmit = async (values) => {
    try {
      const res = await Axios.post("/forgotpassword/", {
        email: checkEmail ? values.emailAndUserId : null,
        user_id: !checkEmail ? values.emailAndUserId : null,
        client_id: !checkEmail ? values.orgId : null,
      });
      //console.log(res.data);
      dispatch(setVerificationStatus(false));
      if (res.data.detail === "mail sent") {
        setMailSent(true);
      } else if (res.data.detail?.uid) {
        //console.log(res.data.detail?.uid);
        history(
          `/setpassword/${res.data.detail?.uid}/${res.data.detail?.token}`
        );
      }
    } catch (err) {
      //console.log(err);
      if (showOrgId) {
        enterValidOrgID(err?.response?.data?.detail);
      } else {
        mailNotSent(err?.response?.data.detail);
      }
      // WrongPassword();
    }
  };
  const navigate = () => {
    history("/");
  };
  const dispatch = useDispatch();
  const handleQuesAns = async (values) => {
    try {
      const res = await Axios.post("/checksecurityquestion/", {
        user_id: values.emailAndUserId,
        client_id: values.orgId,
      });
      //console.log(res.data);
      if (res?.data?.detail?.question_exists) {
        setQuestionExists(true);
        setQuestionlist(res?.data?.detail?.question_list);

        setFieldValue("givenQuestion", res?.data?.detail?.question);

        setFieldValue(
          "givenAnswer",
          (res?.data?.detail?.answer || "").toLowerCase()
        );

        setEnterQnA(true);
      } else {
        OnlyEmailSubmit(values);
      }
    } catch (err) {
      //console.log(err);
      enterValidOrgID(err?.response?.data?.detail);
    }
  };

  // useEffect(() => {
  //   document.addEventListener("keydown", detectKeyDown, true);
  // }, []);
  // const detectKeyDown = (e) => {
  //   if (e.key === "Enter") {
  //     handleNext();
  //   }
  // };
  useEffect(() => {
    const inputField = document.getElementById("inputFieldId");
    if (inputField) {
      inputField.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          event.preventDefault();
        }
      });
    }
  }, []);
  const handleNext = async () => {
    setNextClicked(true);
    if (errors.emailAndUserId === undefined && touched.emailAndUserId) {
      try {
        const res = await Axios.get("/usercheck/", {
          params: { search: values.emailAndUserId },
        });
        if (res.data.exists) {
          if (!checkEmail) {
            setShowOrgId(true);
            setShowPassword(true);
          } else {
            setShowPassword(true);
          }
        } else {
          notExists(res.data.message);
        }
      } catch (err) {
        //console.log(err);
      }
    }
  };
  useEffect(() => {
    if (nextClicked) {
      if (values.emailAndUserId === "" && !touched.emailAndUserId) {
        setNextBlur(true);
      } else {
        setNextBlur(false);
      }
    }
  }, [handleNext]);
  //console.log("values.question:", values.givenAnswer, values.answer);

  const handleSetPasswordClick = (values) => {
    if (checkEmail) {
      OnlyEmailSubmit(values);
    } else {
      if (enterQnA) {
        OnlyEmailSubmit(values);
      } else {
        handleQuesAns(values);
      }
    }
  };
  return (
    <div className="main-co">
      {contextHolder}
      <div
        className="cont"
        style={{ height: questionExists ? "62rem" : "54rem" }}
      >
        <div className="left">
          <img
            alt=""
            src={MAIN_LOGO_BIG}
            className="logo1"
            height={"37px"}
            width={"150px"}
          />
          <div className="signIn_text1">Reset Password</div>
          <div className="text-para1">
            Enter your registered email id below, You will get the email with
            instructions to reset the password
          </div>
          {/* {showPassword && (
            <div className="verified-user-1">
              User is verified &nbsp;
              <CheckCircleTwoTone twoToneColor="#52c41a" />
            </div>
          )} */}
          <form>
            <input
              placeholder="Enter your email or user id"
              className="input-col1"
              type={"text"}
              id="inputFieldId"
              name="emailAndUserId"
              disabled={showPassword ? true : false}
              style={{
                marginTop: "3rem",
              }}
              onChange={(event) => {
                if (event.target.value.match(emailRegex)) {
                  setCheckEmail(true);
                } else {
                  setCheckEmail(false);
                }
                handleChange(event);
              }}
              value={values.emailAndUserId}
              onBlur={handleBlur}
            />
            {showPassword && (
              <CheckCircleTwoTone
                twoToneColor="#52c41a"
                style={{ fontSize: "2rem", marginLeft: ".4rem" }}
              />
            )}

            {nextBlur ? (
              <p className="form-error">please enter either user id or email</p>
            ) : null}

            {errors.emailAndUserId && touched.emailAndUserId ? (
              <p className="form-error">{errors.emailAndUserId}</p>
            ) : null}
            {!showPassword ? (
              <>
                <button
                  className="button-29"
                  onClick={handleNext}
                  type="button"
                  // onKeyDown={(event) => {
                  //   if (event.key === "Enter") {
                  //     handleNext();
                  //   }
                  // }}
                  // onFocus={() => {
                  //   setNextClicked(true);
                  // }}
                  // onBlur={() => setNextClicked(false)}
                  // tabIndex={nextClicked ? 0 : -1}
                >
                  VERIFY USER
                </button>
              </>
            ) : (
              <div>
                {showOrgId && (
                  <>
                    <input
                      placeholder="Orgnization Id"
                      className="input-col-org"
                      type={"text"}
                      name="orgId"
                      onChange={handleChange}
                      value={values.orgId}
                      onBlur={handleBlur}
                    />
                    {errors.orgId && touched.orgId ? (
                      <p className="form-error">{errors.orgId}</p>
                    ) : null}
                    {questionExists && (
                      <>
                        <div>
                          <Select
                            placeholder="Select a security question"
                            name="question"
                            onChange={(option, e) => {
                              // Use setFieldValue to update the question field
                              setFieldValue("question", option);
                              if (option === values.givenQuestion) {
                                setDisAnswer(true);
                              } else {
                                setDisAnswer(false);
                              }
                            }} // Use Formik's handleChange
                            className="new-class-select"
                            onBlur={handleBlur}
                            value={values.question} // Bind to values.question
                            style={{
                              borderRadius: "0.5rem",
                              width: "40rem",
                            }}
                          >
                            {questionList?.map((option) => (
                              <Option key={option.id} value={option.id}>
                                {option.name}
                              </Option>
                            ))}
                          </Select>
                          {errors.question && touched.question ? (
                            <p className="form-error">{errors.question}</p>
                          ) : null}
                          {disAnswer && (
                            <>
                              <input
                                placeholder="Enter your Answer"
                                className="input-col-org"
                                type={"text"}
                                name="answer"
                                onChange={handleChange}
                                value={values.answer}
                                onBlur={handleBlur}
                              />
                              {errors.answer && touched.answer ? (
                                <p className="form-error">{errors.answer}</p>
                              ) : null}
                            </>
                          )}
                        </div>
                      </>
                    )}
                  </>
                )}
                {mailSent ? (
                  <>
                    <div className="mail-sent">
                      Mail is been sent successfully!
                    </div>
                  </>
                ) : (
                  <>
                    {" "}
                    <button
                      className="button-29"
                      onClick={handleSubmit}
                      type="submit"
                    >
                      {showOrgId ? "SET PASSWORD" : "GET MAIL"}
                    </button>
                  </>
                )}
              </div>
            )}
          </form>
        </div>
        <ImagesSlider />
      </div>
      <div className="end-text1">
        To go back and login{" "}
        <span
          style={{ color: " #295BDC", cursor: "pointer" }}
          onClick={navigate}
        >
          Click here
        </span>
      </div>
    </div>
  );
};

export default ForgotPassword;
